<div class="input-group input-group-sm">
    <spv2-company-dropdown [(value)]="value" (valueChange)="valueChange.emit($event)" (userChangedValue)="startDebounce();" ></spv2-company-dropdown>
</div>  